import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  Snackbar,
  Tab,
  Toolbar,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import { Close } from "@mui/icons-material";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "./styles";
import { Profile } from "./Profile";
import { Settings } from "@material-ui/icons";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { Alert, TabContext, TabList, TabPanel } from "@material-ui/lab";
import { StoreSettings } from "./StoreSettings";
import { useI18n } from "../../../../hooks/useI18n";

interface SettingsDialogProps {
  opened: boolean;
  onClose: Function;
  appBarStyle?: any;
}

export interface SettingsChildrenProps {
  onSuccess: () => void;
}

export const SettingsDialog = ({
  opened,
  onClose,
  appBarStyle
}: SettingsDialogProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const { t } = useI18n();

  const [open, setOpen] = useState(opened);
  const [selectedTab, setSelectedTab] = useState("1");
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    setOpen(opened);
  }, [opened]);

  const cancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} fullScreen={isSmall} fullWidth={true} maxWidth={"sm"}>
      {isSmall ? (
        <AppBar style={appBarStyle}>
          <Toolbar>
            <Container>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                py={1}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Settings />
                  <Typography variant={"h6"} style={{ marginLeft: 10 }}>
                    Settings
                  </Typography>
                </div>
                <IconButton onClick={cancel} style={{ color: "white" }}>
                  <Close />
                </IconButton>
              </Box>
            </Container>
          </Toolbar>
        </AppBar>
      ) : (
        <MuiDialogTitle
          disableTypography
          style={{ display: "flex", alignItems: "center", paddingBottom: 4 }}
        >
          <Avatar
            style={{
              backgroundColor: theme.palette.primary.main,
              display: "inline-flex",
              marginRight: 10
            }}
          >
            <Settings />
          </Avatar>
          <Typography variant={"h6"} display={"inline"}>
            Settings
          </Typography>
          <IconButton
            aria-label={t("common.tooltip.close")}
            className={classes.closeButton}
            onClick={cancel}
          >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
      )}
      <TabContext value={selectedTab}>
        <TabList
          scrollButtons="auto"
          variant="scrollable"
          style={{ borderBottom: "1px solid #e0e0e0" }}
          onChange={(event: React.ChangeEvent<{}>, newValue: string) => {
            setSelectedTab(newValue);
          }}
        >
          <Tab label={"Stores"} value="1" />
          <Tab label={"Profile"} value="2" />
        </TabList>
        <TabPanel value={"1"} title={"Stores"}>
          <StoreSettings onSuccess={() => setShowSuccess(true)} />
        </TabPanel>
        <TabPanel value={"2"} title={"Profile"}>
          <Profile onSuccess={() => setShowSuccess(true)} />
        </TabPanel>
      </TabContext>

      <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => {
          setShowSuccess(false);
        }}
      >
        <Alert severity="success">{t("common.messages.settingsSaved")}</Alert>
      </Snackbar>
    </Dialog>
  );
};
